import { FuelTypography } from '@frete.com/fuel-react';
import mobile from 'is-mobile';

import { Grid } from '~components';
import { ReactComponent as CreditAnalysis } from '~assets/credit-analysis-mobile.svg';

import CheckListItem from '../CheckList';
import * as Styled from '../Credit.styled';

function Reproved() {
  const isMobile = mobile();

  return (
    <Styled.Container>
      <Grid container spacing={10} direction="column">
        <Grid className="img-credit-analysis">
          <CreditAnalysis />
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'heading-lg' : 'display-lg'}
            variant="bold"
          >
            Conclua a abertura da sua Conta PJ Fretebras
          </FuelTypography>
        </Grid>
        <Grid>
          <FuelTypography
            size={isMobile ? 'body-sm' : 'body-lg'}
            variant="bold"
            color="neutral-default"
          >
            O crédito inicial para sua empresa não foi aprovado nesse momento
            mas você pode usufruir dos demais benefícios:
          </FuelTypography>
        </Grid>
        <CheckListItem />
        <Grid>
          <FuelTypography
            size="caption"
            variant="medium"
            color="neutral-default"
          >
            Uma nova análise de crédito poderá ser efetuada após 90 dias.
          </FuelTypography>
        </Grid>
      </Grid>
    </Styled.Container>
  );
}

export default Reproved;
